// Pickup time rules: at least 6 hours ahead, at most 6 months ahead.
export const MIN_LEAD_HOURS = 6;
export const MAX_MONTHS = 6;

const pad = (n) => String(n).padStart(2, '0');
const toDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// Pickup times are Zurich wall-clock times: compute "now" in Europe/Zurich regardless of the visitor's timezone (matches backend).
const ZONE = 'Europe/Zurich';
export const zurichNow = () => {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: ZONE, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
  const g = (t) => Number(parts.find((p) => p.type === t).value);
  return new Date(g('year'), g('month') - 1, g('day'), g('hour') % 24, g('minute'));
};

export const minPickup = () => new Date(zurichNow().getTime() + MIN_LEAD_HOURS * 3600 * 1000);
// Earliest bookable slot rounded up to the next full hour; date and time derived from the same Date.
export const defaultSlot = () => { const d = minPickup(); if (d.getMinutes() || d.getSeconds()) { d.setMinutes(0, 0, 0); d.setHours(d.getHours() + 1); } return { date: toDate(d), time: `${pad(d.getHours())}:00` }; };
export const minDate = () => toDate(minPickup());
export const maxDate = () => { const d = zurichNow(); d.setMonth(d.getMonth() + MAX_MONTHS); return toDate(d); };

export const MSG = {
  en: [`Pickup must be at least ${MIN_LEAD_HOURS} hours from now`, `Bookings are possible up to ${MAX_MONTHS} months in advance`],
  de: [`Die Abholung muss mindestens ${MIN_LEAD_HOURS} Stunden im Voraus liegen`, `Buchungen sind bis ${MAX_MONTHS} Monate im Voraus möglich`],
  fr: [`La prise en charge doit avoir lieu au moins ${MIN_LEAD_HOURS} heures à l'avance`, `Réservation possible jusqu'à ${MAX_MONTHS} mois à l'avance`],
  it: [`Il ritiro deve essere almeno ${MIN_LEAD_HOURS} ore da adesso`, `Prenotazioni possibili fino a ${MAX_MONTHS} mesi in anticipo`],
};

// Returns an error message or null.
export const validatePickup = (date, time, lang = 'de') => {
  if (!date) return null;
  const m = MSG[lang] || MSG.en;
  const dt = new Date(`${date}T${time || '00:00'}:00`);
  if (Number.isNaN(dt.getTime())) return m[0];
  if (dt.getTime() < minPickup().getTime()) return m[0];
  if (date > maxDate()) return m[1];
  return null;
};
